import React from "react";
import styled from "styled-components/macro";
import { useSetState } from "../ReduxProvider";
import { useDeviceLang } from "../../hooks/deviceHooks";
import { useViewerDecks } from "queries/viewerQuery";
import LangMenu from "../LangMenu/LangMenu";
import LangButton from "../LangMenu/LangButton";

const Wrap = styled.div`
  opacity: 0.5;
  font-size: ${({ theme }) => theme.duo.fontSize.small};
  line-height: 1.4em;
  text-align: center;
  margin: 10px 10px 10px;
`;
const SLangButton = styled(LangButton)`
  border: none;
  background: none;
  padding: 0;
  transform: scale(0.9);
  svg {
    right: 0;
    transform: scale(0.7);
  }
`;

type Props = {
  inTutorial?: boolean;
};

const AppLang: React.FC<Props> = ({ inTutorial }) => {
  const { appLang } = useDeviceLang();
  const { deck } = useViewerDecks();
  const setPickedLang = useSetState("pickedLang");

  if (inTutorial && deck?.back && appLang === deck.back) return null;

  const handleSelectLang = (lang) => {
    setPickedLang(lang);
  };

  return (
    <Wrap style={inTutorial ? { marginTop: -5 } : undefined}>
      <LangMenu title={<SLangButton lang={appLang} small />} onSelect={handleSelectLang} />
    </Wrap>
  );
};

export default AppLang;
